export default "__VITE_ASSET__DdCZBMVN__"